import React from 'react';
import { credentials } from '../../content/site';

const CredentialStrip = () => (
  <section className="credentials" aria-label="Where we operate">
    <div className="container">
      <div className="credentials__grid">
        {credentials.map((item, i) => (
          <div
            key={item.label}
            className="credentials__item reveal"
            style={{ '--reveal-delay': `${i * 70}ms` }}
          >
            <p className="credentials__label">{item.label}</p>
            <p className="credentials__detail">{item.detail}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default CredentialStrip;
